import {
  CreateModelScopeSettingsItemsRequest,
  DeleteModelScopeSettingsItemsRequest,
  ModelScopesClient,
  ModelScopeSettingResponse,
  ModelScopeSettingType,
  UpdateModelScopeSettingsItemsRequest,
  UpdateModelScopeSettingsRequest,
} from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";

const modelScopesClient = new ModelScopesClient(undefined, axios);

export const useModelScopeSetting = (_mode: ModelScopeSettingType, modelSecopeSettingId: string | null | undefined, options?: any) => {
  return useQuery<ModelScopeSettingResponse | null>({
    ...options,
    queryKey: ["modelScopeSetting", modelSecopeSettingId],
    initialData: null,
    queryFn: async () => modelSecopeSettingId ? modelScopesClient.getModelScopeSetting(modelSecopeSettingId) : new Promise((resolve) => resolve(null)),
  });
};

export const useUpdateModelScopeSetting = (_mode: ModelScopeSettingType, modelSecopeSettingId: string | null | undefined, options?: any) => {
  return useMutation<ModelScopeSettingResponse | null>({
    ...options,
    mutationFn: (updateModelScopeSettingsRequest: UpdateModelScopeSettingsRequest) =>
      modelSecopeSettingId ? modelScopesClient.updateModelScopeSettings(modelSecopeSettingId, updateModelScopeSettingsRequest) : new Promise((resolve) => resolve(null)),
    onSuccess: async (data: ModelScopeSettingResponse) => {
      queryClient.setQueryData(["modelScopeSetting", data.modelScopeSettingId], data);
      options?.onSuccess?.(data);
    },
  });
};

export const useCreateModelScopeSettingItems = (options?: any) => {
  return useMutation<ModelScopeSettingResponse>({
    ...options,
    mutationFn: (createModelScopeSettingsItemsRequest: CreateModelScopeSettingsItemsRequest) =>
      modelScopesClient.createModelScopeSettingItems(createModelScopeSettingsItemsRequest.modelScopeSettingId!, createModelScopeSettingsItemsRequest),
    onSuccess: async (data: ModelScopeSettingResponse) => {
      queryClient.setQueryData(["modelScopeSetting", data.modelScopeSettingId], data);
      options?.onSuccess?.(data);
    },
  });
};

export const useUpdateModelScopeSettingItems = (options?: any) => {
  return useMutation<ModelScopeSettingResponse>({
    ...options,
    mutationFn: (updateModelScopeSettingsItemsRequest: UpdateModelScopeSettingsItemsRequest) =>
      modelScopesClient.updateModelScopeSettingItems(updateModelScopeSettingsItemsRequest.modelScopeSettingId!, updateModelScopeSettingsItemsRequest),
    onSuccess: async (data: ModelScopeSettingResponse) => {
      queryClient.setQueryData(["modelScopeSetting", data.modelScopeSettingId], data);
      options?.onSuccess?.(data);
    },
  });
};

export const useDeleteModelScopeSettingItems = (options?: any) => {
  return useMutation<ModelScopeSettingResponse>({
    ...options,
    mutationFn: (deleteModelScopeSettingsItemsRequest: DeleteModelScopeSettingsItemsRequest) =>
      modelScopesClient.deleteModelScopeSettingItems(deleteModelScopeSettingsItemsRequest.modelScopeSettingId!, deleteModelScopeSettingsItemsRequest),
    onSuccess: async (data: ModelScopeSettingResponse) => {
      queryClient.setQueryData(["modelScopeSetting", data.modelScopeSettingId], data);
      options?.onSuccess?.(data);
    },
  });
};
